module.exports = __webpack_public_path__ + "img/ic_joinclass.bed35d6b.svg";